import { CheckNotes, InspectionCase } from '../inspection-cases';

export class SpecialInstallationsDto extends InspectionCase {
  item_12_1_1?: InspectionCase;
  item_12_1_2?: InspectionCase;
  item_12_2_1?: InspectionCase;
  item_12_2_2?: InspectionCase;
  item_12_3_1?: InspectionCase;
  item_12_3_2?: InspectionCase;
  item_12_4_1?: InspectionCase;
  item_12_4_2?: InspectionCase;
  item_12_4_3?: InspectionCase;
  item_12_5_1?: InspectionCase;
  item_12_5_2?: InspectionCase;
  item_12_5_3?: InspectionCase;
  item_12_5_4?: InspectionCase;
  item_12_5_5?: InspectionCase;
  item_12_5_6?: InspectionCase;
  item_12_5_7?: InspectionCase;
  item_12_5_8?: InspectionCase;
  item_12_5_9?: InspectionCase;
  item_12_5_10?: InspectionCase;
}

export class SpecialInstallations extends SpecialInstallationsDto {
  constructor(data: SpecialInstallationsDto = { title: 'התקנות מיוחדות' }) {
    super(data);
    this.item_12_1_1 = new InspectionCase({
      ...data.item_12_1_1,
      title: `בחדר קירור המותקן במפעל או בתוך מחסן וגודלו מעל 40 מ"ר והטמפ' שלו נמוכה מ-8 מעלות צל' , מותקן מערכת יניקה (אם מותקנת מערכת מתזים אין צורך במערכת יניקה)`
    });
    this.item_12_1_2 = new InspectionCase({
      ...data.item_12_1_2,
      title: `בחדר קירור שבמבנה מופרד וגודלו מעל 500 מ"ר וטמפ' נמוכה מ-8 מעלות צל' הותקנה מערכת יניקה (אם מותקנת מערכת מתזים אין צורך במערכת יניקה)`
    });
    this.item_12_2_1 = new InspectionCase({
      ...data.item_12_2_1,
      title: `המרחק בין הגלאים 3.7 מ' והמרק בין קיר לגלאי 1.8 מ'`
    });
    this.item_12_2_2 = new InspectionCase({
      ...data.item_12_2_2,
      title: `הותקן נורת סימון על גבי הקיר בגובה של 2-1.4 מ' או בתקרה מעל הגלאי יחד עם שלט " נורית סימון  לגלאי ברצפה צפה" או מפה סינופטית שתציין ע"י הדלקת נורית את מיקום הגלאי . המפה תותקן בכניסה לחלל`
    });
    this.item_12_3_1 = new InspectionCase({
      ...data.item_12_3_1,
      title: `התקנת גלאי הכבל בוצעה בהתאם לציור 4 בתקן (יש לציין את אופן התקנה)`
    });
    this.item_12_3_2 = new InspectionCase({
      ...data.item_12_3_2,
      title: `התקנת גלאי עשן מתחת לרצפות צפות מבוצעות בהתאם לציור 7 בתקן  ,שטח השגחה לגלאי - 11 מ'`
    });
    this.item_12_4_1 = new InspectionCase({
      ...data.item_12_4_1,
      title: `קביעת מיקום הגלאים בבית הסוהר`
    });
    this.item_12_4_2 = new InspectionCase({
      ...data.item_12_4_2,
      title: `בהתאם לשיקול דעתו של המתכנן / שירותי כבאות`
    });
    this.item_12_4_3 = new InspectionCase({
      ...data.item_12_4_3,
      title: `לחצנים ידניים הותקנו בחדר מרכז שליטה ובחדר קצין הבטחון.`
    });
    this.item_12_5_1 = new InspectionCase({
      ...data.item_12_5_1,
      title: `בחדר באווירה נפיצה הותקנו גלאי עשן מוגן התפוצצות:`
    });
    this.item_12_5_2 = new InspectionCase({
      ...data.item_12_5_2,
      title: `דגם הגלאי , דגם החוצץ`
    });
    this.item_12_5_3 = new InspectionCase({
      ...data.item_12_5_3,
      title: `החוצץ של הגלאי מוגן התפוצצות מחוץ לחדר הנפיץ בתוך קופסא עם סימון של " מוגן התפוצצות"`
    });
    this.item_12_5_4 = new InspectionCase({
      ...data.item_12_5_4,
      title: `בוצעה אטימה במעבר המובילים דרך הקירות וליד גלאי העשן למניעת בריחת גז מימן`
    });
    this.item_12_5_5 = new InspectionCase({
      ...data.item_12_5_5,
      title: `הגלאי מוגן ההתפוצצות והחוצץ הגלאי מוגן ההתפוצצות   מאושרים לעבודה ביחד עם דגם הגלאי מצוין בקטלוג החוצץ`
    });
    this.item_12_5_6 = new InspectionCase({
      ...data.item_12_5_6,
      title: `כמות הגלאים המחוברים לחוצץ אחד הינו בהתאם לכמות המצוינת בהוראות החיבור של החוצץ (בד"כ עד 5 גלאים )`
    });
    this.item_12_5_7 = new InspectionCase({
      ...data.item_12_5_7,
      title: `הארקה של יחידת החוצץ נעשה בהתאם להוראות יצרן החוצץ`
    });
    this.item_12_5_8 = new InspectionCase({
      ...data.item_12_5_8,
      title: `לא חוברו מנורות סימון לגלאי מוגן התפוצצות`
    });
    this.item_12_5_9 = new InspectionCase({
      ...data.item_12_5_9,
      title: `במערכת האוורור מספר החלפות האוויר בחדר מאפשרים שימוש הגלאי עשן רגיל`
    });
    this.item_12_5_10 = new InspectionCase({
      ...data.item_12_5_10,
      title: `יש חיווי ביחידת הבקרה על ניתוק או הפסקת מערכת פעולת החלפת האוויר  .בעקבות הפסקת פעולת מערכת האוורור נותקה מערכת טעינת המצברים`
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.item_12_1_1.isApplicable || this.item_12_1_1.isPassed) &&
        (!this.item_12_1_2.isApplicable || this.item_12_1_2.isPassed) &&
        (!this.item_12_2_1.isApplicable || this.item_12_2_1.isPassed) &&
        (!this.item_12_2_2.isApplicable || this.item_12_2_2.isPassed) &&
        (!this.item_12_3_1.isApplicable || this.item_12_3_1.isPassed) &&
        (!this.item_12_3_2.isApplicable || this.item_12_3_2.isPassed) &&
        (!this.item_12_4_1.isApplicable || this.item_12_4_1.isPassed) &&
        (!this.item_12_4_2.isApplicable || this.item_12_4_2.isPassed) &&
        (!this.item_12_4_3.isApplicable || this.item_12_4_3.isPassed) &&
        (!this.item_12_5_1.isApplicable || this.item_12_5_1.isPassed) &&
        (!this.item_12_5_2.isApplicable || this.item_12_5_2.isPassed) &&
        (!this.item_12_5_3.isApplicable || this.item_12_5_3.isPassed) &&
        (!this.item_12_5_4.isApplicable || this.item_12_5_4.isPassed) &&
        (!this.item_12_5_5.isApplicable || this.item_12_5_5.isPassed) &&
        (!this.item_12_5_6.isApplicable || this.item_12_5_6.isPassed) &&
        (!this.item_12_5_7.isApplicable || this.item_12_5_7.isPassed) &&
        (!this.item_12_5_8.isApplicable || this.item_12_5_8.isPassed) &&
        (!this.item_12_5_9.isApplicable || this.item_12_5_9.isPassed) &&
        (!this.item_12_5_10.isApplicable || this.item_12_5_10.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.item_12_1_1.getNotes(),
      ...this.item_12_1_2.getNotes(),
      ...this.item_12_2_1.getNotes(),
      ...this.item_12_2_2.getNotes(),
      ...this.item_12_3_1.getNotes(),
      ...this.item_12_3_2.getNotes(),
      ...this.item_12_4_1.getNotes(),
      ...this.item_12_4_2.getNotes(),
      ...this.item_12_4_3.getNotes(),
      ...this.item_12_5_1.getNotes(),
      ...this.item_12_5_2.getNotes(),
      ...this.item_12_5_3.getNotes(),
      ...this.item_12_5_4.getNotes(),
      ...this.item_12_5_5.getNotes(),
      ...this.item_12_5_6.getNotes(),
      ...this.item_12_5_7.getNotes(),
      ...this.item_12_5_8.getNotes(),
      ...this.item_12_5_9.getNotes(),
      ...this.item_12_5_10.getNotes()
    ];
  }
}
